/**
* AccountInfoController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';AccountInfoController.$inject = ["$rootScope", "$http", "$scope", "$stateParams", "Authentication", "Profile", "Snackbar", "affilate", "$analytics", "$state", "currency", "Funnel", "UserService", "Sync"];

  angular.
  module('gplans.store.controllers').
  controller('AccountInfoController', AccountInfoController);

  AccountInfoController.$inject = ['$rootScope', '$http', '$scope', '$stateParams', 'Authentication', 'Profile',
  'Snackbar', 'affilate', '$analytics', '$state', 'currency', 'Funnel', 'UserService', 'Sync'];

  /**
                                                                                                * @namespace AccountInfoController
                                                                                                */
  function AccountInfoController($rootScope, $http, $scope, $stateParams, Authentication, Profile, Snackbar, affilate,
  $analytics, $state, currency, Funnel, UserService, Sync) {
    var vm = this;

    activate();

    function activate() {
      // we don't wan't intercom messages on this page
      //if (window.Intercom) {
      //  window.Intercom('shutdown');
      // noinspection JSAnnotator
      //  delete window.Intercom;
      //}

      if (affilate && affilate.type === 'Clickbank') {
        vm.clickbank = true;
      }

      Authentication.check().then(function (res) {

        if (!Sync.initialized) Sync._initialize();

        vm.userData = { email: UserService.data.email, username: UserService.data.username };
        vm.user = res.data;
        getPlan().then(function (res) {
          vm.plan = res.data;
        });

      });

      if (currency == 'GBP') {
        vm.currencySymbol = '£';
      } else if (currency == 'AUD' || currency == 'CAD') {
        vm.currencySymbol = currency + '$';
      } else {
        vm.currencySymbol = '$';
      }
    }

    function getPlan() {
      var req = $http({
        url: gplansConf.API_URL + '/api/v1/plans/' + $stateParams.plan + '/',
        method: "GET" });

      return req;
    }

    vm.checkUsername = function () {
      vm.checkingUsername = true;
      var req = $http.get(gplansConf.API_URL + '/api/v1/usernames/?username=' + vm.userData.username).then(function (data) {
        var taken = !!data.data.length && data.data[0];
        if (taken) {
          taken = data.data[0].username !== UserService.data.username;
        }
        vm.checkingUsername = false;
        vm.usernameTaken = taken;
      }, function (err) {
        vm.checkingUsername = false;
      });
      return req;
    };

    vm.updateProfile = function () {
      vm.emailTaken = null;
      Profile.update(vm.userData, UserService.data.username).then(profileSuccess, profileError);

      function profileSuccess(res) {
        UserService.set(res.data);
        Authentication.setAuthenticatedAccount(res.data);
        Funnel.nextStep();
      }

      function profileError(err) {
        vm.verificationCodeMismatch = false;
        for (var key in err.data) {
          if (key == 'verification_code') vm.verificationCodeMismatch = true;
          if (key == 'email') vm.emailError = err.data[key] + '';
          Snackbar.error(err.data[key][0]);
        }
      }
    };

    // $scope.$watch('vm.plan', function (newVal, oldVal) {
    //   console.log("Plan: " + newVal);
    //   if(newVal && newVal.name){
    //     var props = {};
    //     props['Plan ' + newVal.name + ' Purchased'] = 'Plan ' + newVal.name;
    //     $analytics.eventTrack('Plan Purchased', props);
    //   }
    // });
  }
})();